<template>
	<transition name="fade">
		<div class="popup-product" v-if="show" :data-product-id='product.id'>
			<div class="popup-product__overlay" @click="$emit('click', $event = false); cleanUrl()"></div>
			<div class="popup-product__shadow">
				<div class="popup-product__content scrollable">
					<div class="popup-product__main">
                        <span class="popup-product__close" @click="$emit('click', $event = false); cleanUrl()">
                            <SvgIcon class="ico-shape-big color-happy-blue" iconName="ico-shape"/>
                            <SvgIcon class="ico-shape-small color-white" iconName="ico-shape"/>
                            <SvgIcon class="ico-times color-happy-blue" iconName="ico-times-slim"/>
                        </span>
						<div class="popup-product__img-cont">
							<img class="img-contain" :src="product.image" alt="">
						</div>
						<div class="popup-product__details">
							<span class="popup-product__hand-title">{{ getCategoryName() }}</span>
							<h2 class="popup-product__title">{{ product.title }}</h2>
							<div class="popup-product__tags">
								<div class="popup-product__tags-wrap" v-if="product.tag">
									<span v-for="tag in product.tag.split(',')" :key="tag" class="popup-product__tag">{{ tag }}</span>
								</div>
							</div>
							<div class="entry-content">
								<p>{{ product.description }}</p>
							</div>
							<div v-if="product.attributes.length < 1" class="popup-product-slide__sizes">
								<!--<p class="popup-product-slide__label-price">Single price: ${{ product.price }}</p>-->
								<p class="popup-product__subtitle">Size Options</p>
								<div>
									<label class="popup-product__label">
										<input class="popup-product__radio" type="radio" checked="checked"/>
										<!--v-model="attrID"-->
										<span class="popup-product__custom-radio"></span>
										<span class="popup-product__radio-cont">
											<img class="img-contain" :src="product.image" alt="">
										</span>
										<span class="popup-product__radio-det">
											<!-- todo: refactor name -->
											<span class="popup-product__radio-text-cont">
												<span class="popup-product__label-name">{{ product.size }}</span>
												<span class="popup-product__label-price">${{ product.price }}</span>
											</span>
											<span class="popup-product__feeds color-happy-blue">
												<SvgIcon class="popup-products__feed-ico" iconName="ico-users"/>
												{{ product.feeds_number }}
											</span>
										</span>
									</label>
								</div>
							</div>
							<div v-if="product.attributes.length > 0" class="popup-product__sizes">
								<p class="popup-product__subtitle">Size Options</p>
								<div v-for="attr in product.attributes" :key="attr.variation_id">
									<label class="popup-product__label">
										<input :data-id="attr.variation_id" :data-feed="attr.serving_size" class="popup-product__radio" type="radio" @click="getPrice(attr.price); getAttrData(attr.variation_id, attr.title); getFeeds(attr.serving_size)" name="size" :value="attr.variation_id" :checked="attr.checked">
										<!--v-model="attrID"-->
										<span class="popup-product__custom-radio"></span>
										<span class="popup-product__radio-cont">
											<img class="img-contain" :src="attr.image" alt="">
										</span>
										<span class="popup-product__radio-det">
											<!-- todo: refactor name -->
											<span class="popup-product__radio-text-cont">
												<span class="popup-product__label-name">{{ attr.name_var }}</span>
												<span class="popup-product__label-price">${{ attr.price }}</span>
											</span>
											<span class="popup-product__feeds color-happy-blue">
												<SvgIcon class="popup-products__feed-ico" iconName="ico-users"/>
												{{ attr.serving_size }}
											</span>
										</span>
									</label>
								</div>
							</div>
						</div>
					</div>
					<div class="popup-product__footer">
						<div class="popup-product__footer-left">
							<span class="popup-product__qty">QTY</span>
							<div class="popup-product__input-wrap">
                                <span class="popup-product__decrement in-dec" v-on:click="counter">
                                    <SvgIcon class="popup-product__decrement-ico" iconName="ico-minus"/>
                                </span>
								<input class="popup-product__input js-popup-product__input" type="number" v-model.number="quantity" @blur="checkMinOrder" :min="this.product.min_order" :max="this.product.max_order">
								<span class="popup-product__increment in-inc" v-on:click="counter">
                                    <SvgIcon class="popup-product__increment-ico" iconName="ico-plus"/>
                                </span>
							</div>
							<p class="popup-product__footer-feed color-happy-blue">
								<SvgIcon class="popup-products__feed-ico" iconName="ico-users"/>
								<span v-if="product.attributes.length > 0">*This will feed approx. {{
										calculateApprox(getFeeds)
									}}.</span>
								<span v-else>*This will feed approx. {{ calculateApprox() }}.</span>
							</p>

						</div>
						<div class="popup-product__footer-right">
							<span class="popup-product__footer-price">${{
									(parseFloat(this.product.price) * this.quantity).toFixed(2)
								}}</span>
							<a href="" class="btn btn--ico-2" @click="addToCart(product.id, $event)">
								<SvgIcon class="btn__ico" iconName="ico-shopping-basket"/>
								Add to cart
							</a>
						</div>
						<span v-if="product.min_order > 1" class="popup-product__small">*Minimum order {{
								product.min_order
							}}</span>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import SvgIcon from '../base/SvgIcon/SvgIcon.vue';
import axios from 'axios';

export default {
	props: {
		show: Boolean,
		product: Object,
	},
	watch: {
		product() {
			if (this.product.min_order === '') {
				this.quantity = 1;
				// eslint-disable-next-line camelcase
				this.product.min_order = 1;
			} else {
				this.quantity = this.product.min_order;
			}
		}
	},
	methods: {
		cleanUrl: function() {
			let url = window.location.href;
			if (url.includes('?product-popup')) {
				url = url.split('?product-popup')[0];
			}
			window.history.pushState('page', 'Title', url);
		},

		getCategoryName: function() {
			const currentCategory = document.querySelector('.js-category-name').getAttribute('data-cat-name');
			const productCategory = this.product.category;
			if (productCategory.includes(currentCategory)) {
				return currentCategory;
			}

			return currentCategory;
		},
		getFeeds: function(e) {
			const attrs = this.product.attributes;
			if (attrs) {
				for (let i = 0; i < attrs.length; i++) {
					attrs[i].checked = '';
					if (attrs[i].serving_size === e) {
						attrs[i].checked = 'true';
					}
				}
			}
		},
		calculateApprox: function() {
			let feedsNumber;
			let feeds;
			const attrs = this.product.attributes;
			if (attrs.length < 1) {
				feeds = this.product.feeds_number;
			} else {
				for (let i = 0; i < attrs.length; i++) {
					if (attrs[i].checked === 'true') {
						feeds = attrs[i].serving_size;
					}
				}
			}

			if (String(feeds).includes('-')) {
				const feedsAmount = feeds.split('-');
				const lower = parseInt(feedsAmount[0]) * this.quantity;
				const higher = parseInt(feedsAmount[1]) * this.quantity;
				feedsNumber = lower + '-' + higher;
			} else {
				feedsNumber = feeds * this.quantity;
			}

			if (parseInt(feedsNumber) === 1) {
				feedsNumber = feedsNumber + ' person';
			} else {
				feedsNumber = feedsNumber + ' people';
			}
			return feedsNumber;
		},
		checkMinOrder: function() {
			if (this.quantity <= this.product.min_order) {
				this.quantity = this.product.min_order;
			}
		},
		counter: function(event) {
			if (event.currentTarget.classList.contains('in-inc')) {
				this.quantity++;
			}
			if (event.currentTarget.classList.contains('in-dec')) {
				if (this.quantity <= this.product.min_order) return;
				this.quantity--;
			}
		},
		getAttrData: function(attrID, attrTitle) {
			this.attrID = attrID;
			this.attrTitle = attrTitle;
		},
		getPrice: function(price) {
			this.product.price = price;
		},
		addToCart: function(id, event) {
			const gPreloader = document.querySelector('.js-g-preloader');
			gPreloader.classList.add('global-preloader--active');
			event.preventDefault();

			const data = {
				// eslint-disable-next-line camelcase
				product_id: id,
				// eslint-disable-next-line camelcase
				variation_id: this.attrID,
				attribute: '',
				quantity: this.quantity
			};

			this.attrID = '';
			this.attrTitle = '';

			console.log(data);

			axios.post('/wp-json/fws/v1/add-to-cart', data)
				.then(response => {
					if (response.data.status === 'success') {
						// this.show = false;
						this.$emit('changeShow');
						const popup = document.querySelector('.js-popup-item-success');
						popup.classList.add('show');
						const miniCart = document.querySelector('.js-cart-slide');
						const miniCartUpdate = response.data.cart;
						const div = document.createElement('div');
						div.innerHTML = miniCartUpdate;
						const innerDiv = div.querySelector('.js-cart-slide');
						miniCart.remove();
						document.getElementById('masthead').appendChild(innerDiv);

						const counter = document.querySelector('.site-header__num');
						counter.innerHTML = response.data.count;
						const showSlide = document.getElementsByClassName('js-cart-slide-show');
						const hideSlide = document.getElementsByClassName('js-cart-slide-hide');
						const cart = document.getElementsByClassName('js-cart-slide');
						const body = document.getElementsByTagName('body');
						const overlay = document.getElementsByClassName('cart-slide__overlay');

						showSlide[0].addEventListener('click', function() {
							cart[0].classList.remove('cart-slide--hidden');
							body[0].classList.add('cart-slide-shown');
							overlay[0].style.display = 'block';
						});

						for (let i = 0; i < hideSlide.length; i++) {
							hideSlide[i].addEventListener('click', function() {
								cart[0].classList.add('cart-slide--hidden');
								body[0].classList.remove('cart-slide-shown');
								overlay[0].style.display = 'none';
							});
						}
						gPreloader.classList.remove('global-preloader--active');
					}
				})
				.catch(error => console.log(error));
		},
	},
	components: {
		SvgIcon
	},
	data() {
		return {
			quantity: 10,
			min: 10,
			max: 200,
			price: this.product.price,
			feeds: this.product.feeds,
			variationID: '',
			attrID: '',
			attrTitle: ''
		};
	}
};
</script>

<style lang="scss" scoped>
.popup-product {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100%;
	z-index: 100000;
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;

	.entry-content {
		margin-top: 18px;
		margin-bottom: 23px;

		p {
			line-height: 30px;
		}
	}
}

.popup-product__overlay {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba($catskill-white, 0.9);
}

.popup-product__shadow {
	filter: drop-shadow(5px 8px 15px rgba(31, 66, 94, 0.07));
	width: 100%;
	max-width: 1200px;
}

.popup-product__content {
	position: relative;
	z-index: 1;
	width: 100%;
	max-height: 100vh;
	padding: 96px 100px 68px;
	overflow-y: scroll;
	-webkit-overflow-scrolling: touch;
	background-color: $white;
	clip-path: polygon(
			0 0,
			1.16% 14px,
			2.33% 0,
			3.49% 14px,
			4.65% 0,
			5.81% 14px,
			6.98% 0,
			8.14% 14px,
			9.30% 0,
			10.47% 14px,
			11.63% 0,
			12.79% 14px,
			13.95% 0,
			15.12% 14px,
			16.28% 0,
			17.44% 14px,
			18.60% 0,
			19.77% 14px,
			20.93% 0,
			22.09% 14px,
			23.26% 0,
			24.42% 14px,
			25.58% 0,
			26.74% 14px,
			27.91% 0,
			29.07% 14px,
			30.23% 0,
			31.40% 14px,
			32.56% 0,
			33.72% 14px,
			34.88% 0,
			36.05% 14px,
			37.21% 0,
			38.37% 14px,
			39.53% 0,
			40.70% 14px,
			41.86% 0,
			43.02% 14px,
			44.19% 0,
			45.35% 14px,
			46.51% 0,
			47.67% 14px,
			48.84% 0,
			50% 14px,
			51.16% 0,
			52.33% 14px,
			53.49% 0,
			54.65% 14px,
			55.81% 0,
			56.98% 14px,
			58.14% 0,
			59.30% 14px,
			60.47% 0,
			61.63% 14px,
			62.79% 0,
			63.95% 14px,
			65.12% 0,
			66.28% 14px,
			67.44% 0,
			68.60% 14px,
			69.77% 0,
			70.93% 14px,
			72.09% 0,
			73.26% 14px,
			74.42% 0,
			75.58% 14px,
			76.74% 0,
			77.91% 14px,
			79.07% 0,
			80.23% 14px,
			81.40% 0,
			82.56% 14px,
			83.72% 0,
			84.88% 14px,
			86.05% 0,
			87.21% 14px,
			88.37% 0,
			89.53% 14px,
			90.70% 0,
			91.86% 14px,
			93.02% 0,
			94.19% 14px,
			95.35% 0,
			96.51% 14px,
			97.67% 0,
			98.84% 14px,
			100% 0,
			100% 100%,
			98.84% calc(100% - 14px),
			97.67% 100%,
			96.51% calc(100% - 14px),
			95.35% 100%,
			94.19% calc(100% - 14px),
			93.02% 100%,
			91.86% calc(100% - 14px),
			90.70% 100%,
			89.53% calc(100% - 14px),
			88.37% 100%,
			87.21% calc(100% - 14px),
			86.05% 100%,
			84.88% calc(100% - 14px),
			83.72% 100%,
			82.56% calc(100% - 14px),
			81.40% 100%,
			80.23% calc(100% - 14px),
			79.07% 100%,
			77.91% calc(100% - 14px),
			76.74% 100%,
			75.58% calc(100% - 14px),
			74.42% 100%,
			73.26% calc(100% - 14px),
			72.09% 100%,
			70.93% calc(100% - 14px),
			69.77% 100%,
			68.60% calc(100% - 14px),
			67.44% 100%,
			66.28% calc(100% - 14px),
			65.12% 100%,
			63.95% calc(100% - 14px),
			62.79% 100%,
			61.63% calc(100% - 14px),
			60.47% 100%,
			59.30% calc(100% - 14px),
			58.14% 100%,
			56.98% calc(100% - 14px),
			55.81% 100%,
			54.65% calc(100% - 14px),
			53.49% 100%,
			52.33% calc(100% - 14px),
			51.16% 100%,
			50% calc(100% - 14px),
			48.84% 100%,
			47.67% calc(100% - 14px),
			46.51% 100%,
			45.35% calc(100% - 14px),
			44.19% 100%,
			43.02% calc(100% - 14px),
			41.86% 100%,
			40.70% calc(100% - 14px),
			39.53% 100%,
			38.37% calc(100% - 14px),
			37.21% 100%,
			36.05% calc(100% - 14px),
			34.88% 100%,
			33.72% calc(100% - 14px),
			32.56% 100%,
			31.40% calc(100% - 14px),
			30.23% 100%,
			29.07% calc(100% - 14px),
			27.91% 100%,
			26.74% calc(100% - 14px),
			25.58% 100%,
			24.42% calc(100% - 14px),
			23.26% 100%,
			22.09% calc(100% - 14px),
			20.93% 100%,
			19.77% calc(100% - 14px),
			18.60% 100%,
			17.44% calc(100% - 14px),
			16.28% 100%,
			15.12% calc(100% - 14px),
			13.95% 100%,
			12.79% calc(100% - 14px),
			11.63% 100%,
			10.47% calc(100% - 14px),
			9.30% 100%,
			8.14% calc(100% - 14px),
			6.98% 100%,
			5.81% calc(100% - 14px),
			4.65% 100%,
			3.49% calc(100% - 14px),
			2.33% 100%,
			1.16% calc(100% - 14px),
			0 100%
	);

	&::-webkit-scrollbar {
		width: 11px;
	}

	&::-webkit-scrollbar-track {
		background: $iceberg;
		border-radius: 10px;
	}

	&::-webkit-scrollbar-thumb {
		background: $happy-blue;
		border-radius: 10px;

		&:hover {
			background: darken($happy-blue, 10%);
		}
	}

	@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
		scrollbar-base-color: $iceberg;
		scrollbar-face-color: $happy-blue;
		scrollbar-highlight-color: $happy-blue;
		scrollbar-track-color: $iceberg;
		scrollbar-arrow-color: $happy-blue;
		scrollbar-shadow-color: $happy-blue;
		scrollbar-dark-shadow-color: $happy-blue;
	}

	@include mq($lg) {
		height: 100vh;
		clip-path: none;
		padding: 96px 30px 30px;
	}

	@include mq($md) {
		padding: 50px 30px 30px;
	}
	@include mq($sm) {
		/* padding: 50px 15px 20px; */
		padding: 50px 15px 90px;

		@supports (-webkit-appearance:none) {
			padding: 50px 15px 130px;
		}
	}
}

.popup-product__close {
	position: absolute;
	z-index: 1;
	top: 51px;
	right: 39px;
	display: inline-block;
	width: 68px;
	height: 68px;
	cursor: pointer;

	.ico-shape-big {
		font-size: 68px;
		height: 68px;
		width: 68px;
		transition: color $dur $ease;
	}

	.ico-shape-small {
		position: absolute;
		top: 2px;
		left: 2px;
		font-size: 64px;
		height: 64px;
		width: 64px;
	}

	.ico-times {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 68px;
		height: 68px;
		font-size: 21px;
		align-items: center;
		justify-content: center;
		transition: color $dur $ease;
	}

	&:hover {
		.ico-shape-big,
		.ico-times {
			color: $burning-orange;
		}
	}

	@include mq($md) {
		top: 20px;
		right: 30px;

		width: 38px;
		height: 38px;

		.ico-shape-big {
			font-size: 38px;
			height: 38px;
			width: 38px;
		}

		.ico-shape-small {
			font-size: 34px;
			height: 34px;
			width: 34px;
		}

		.ico-times {
			width: 38px;
			height: 38px;
			font-size: 16px;
		}
	}
}

.popup-product__main {
	display: flex;
	padding-bottom: 45px;
	border-bottom: 1px solid $iceberg;
	align-items: center;

	@include mq($md) {
		flex-direction: column;
		padding-bottom: 25px;
	}
}

.popup-product__img-cont {
	position: relative;
	/* width: 39.24%; */
	width: 44.24%;
	padding-top: 39.24%;
	overflow: hidden;
	/* margin-top: 25px; */
	/* margin-left: 41px; */

	@include mq($md) {
		margin: 0;
		margin-bottom: 20px;
		padding-top: 0;
		width: 100%;
		max-width: 300px;
		height: 300px;
	}

	@include mq($sm) {
		max-width: 220px;
		height: 220px;
	}
}

.popup-product__details {
	width: 46.61%;
	max-width: 467px;
	margin-left: auto;
	@include mq($md) {
		width: 100%;
		max-width: 100%;
		margin-left: 0;
	}
}

.popup-product__hand-title {
	display: block;
	font-size: 48px;
	line-height: 1;
	font-family: $font-third;
	margin-bottom: 14px;

	@include mq($lg) {
		font-size: 40px;
	}

	@include mq($md) {
		font-size: 30px;
	}
}

.popup-product__title {
	font-family: $font-fourth;
	font-size: 48px;
	line-height: 1;
	text-transform: uppercase;
	color: $burning-orange;
	margin-bottom: 20px;
	@include mq($lg) {
		font-size: 40px;
	}

	@include mq($md) {
		font-size: 35px;
	}
}

.popup-product__tags {
	@include mq($sm) {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
	}
}

.popup-product__tag {
	display: inline-flex;
	align-items: center;
	height: 36px;
	padding: 0 19px;
	background-color: $iceberg;
	color: $happy-blue;
	border-radius: 20px;
	font-size: 16px;
	line-height: 1;
	font-family: $font-second;
	margin-right: 13px;
	@include mq($sm) {
		margin-right: 0;
		margin-bottom: 10px;
	}
}

.popup-product__prep {
	display: inline-flex;
	align-items: center;
	height: 27px;
	padding: 0 11px;
	background-color: $karry;
	color: $burning-orange;
	font-family: $font-second;
	font-size: 15px;
	border-radius: 4px;

	.ico-watch {
		font-size: 11px;
		width: 11px;
		height: 11px;
		margin-right: 10px;
	}
}

.popup-product__subtitle {
	font-family: $font-second;
	font-size: 30px;
	margin-bottom: 10px;

	@include mq($lg) {
		font-size: 25px;
	}
}

.popup-product__label {
	display: flex;
	align-items: center;
	margin-top: 20px;
}

.popup-product__radio-cont {
	position: relative;
	overflow: hidden;
	width: 80px;
	height: 53px;
	margin-right: 21px;

	@include mq($md) {
		min-width: 50px;
	}
}

.popup-product__radio {
	appearance: none;
	position: absolute;
	opacity: 0;
	pointer-events: none;

	&:checked {
		& + .popup-product__custom-radio::after {
			opacity: 1;
		}
	}
}

.popup-product__custom-radio {
	flex-shrink: 0;
	position: relative;
	display: inline-block;
	width: 28px;
	height: 28px;
	border-radius: 50%;
	box-shadow: inset 2px 3px 4px rgba($happy-blue, 0.25);
	border: 1px solid $ziggurat;
	margin-right: 15px;

	&::after {
		content: '';
		position: absolute;
		width: 14px;
		height: 14px;
		border-radius: 50%;
		background-color: $burning-orange;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		opacity: 0;
		transition: opacity $dur $ease;
	}
}

.popup-product__radio-det {
	display: flex;
	max-width: 210px;
	flex-wrap: wrap;
	align-items: center;
	min-width: 200px;
	justify-content: space-between;

	@include mq($sm) {
		flex-direction: column;
		align-items: flex-start;
		max-width: 100%;
		min-width: 160px;
	}
}

.popup-product__label-name {
	font-family: $font-second;
	font-size: 18px;
	/* margin-right: auto; */
	width: 100%;
	max-width: 150px;
	margin-right: 0;
	@include mq($sm) {
		margin-right: 0;
		margin-bottom: 3px;
	}
}

.popup-product__radio-text-cont {
	display: flex;
	/* justify-content: space-between; */
	align-items: center;
	min-width: 200px;

	@include mq($md) {
		min-width: 150px;
	}
}

.popup-product__label-price {
	font-size: 20px;
	letter-spacing: 1px;
	font-weight: 500;
}

.popup-product__feeds {
	display: inline-flex;
	align-items: center;
	width: 100%;
	font-family: $font-second;
	font-size: 16px;
	margin-top: 2px;
	padding-left: 3px;

	.popup-products__feed-ico,
	svg {
		font-size: 17px;
		width: 19px;
		height: 15px;
		margin-right: 4px;
	}
}

.popup-product__footer {
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-wrap: wrap;
	padding: 33px 2px 0;

	@include mq(1023px) {
		flex-direction: column;
		align-items: center;
	}
}

.popup-product__footer-right,
.popup-product__footer-left {
	display: flex;
	align-items: center;
}

.popup-product__footer-left {
	@include mq($sm) {
		/* flex-direction: column;
		align-items: center; */
		flex-wrap: wrap;
		justify-content: center;
		align-items: center;
		/* flex-direction: row; */
		flex-direction: row-reverse;
	}
}

.popup-product__footer-right {
	@include mq(1200px) {
		order: 3;
		margin-top: 10px;
	}

	@include mq(1024px) {
		margin-top: 0;
	}

	@include mq(992px) {
		margin-top: 10px;
	}

	@include mq($sm) {
		/* flex-direction: column; */
		flex-direction: row;
		justify-content: center;
		align-items: center;
	}
}

.popup-product__qty,
.popup-product__footer-price {
	font-size: 30px;
	font-weight: 500;
	letter-spacing: 1.5px;

	@include mq(1200px) {
		font-size: 25px;
		letter-spacing: 1px;
	}
	@include mq(1024px) {
		font-size: 20px;
	}
}

.popup-product__qty {
	margin-right: 17px;

	@include mq(1200px) {
		margin-right: 10px;
	}

	@include mq($sm) {
		margin-right: 0;
		/* margin-bottom: 10px; */
		margin-bottom: 0;
		/* margin-right: 20px; */
		margin-left: 20px;
	}
}

.popup-product__footer-price {
	margin-right: 37px;
	@include mq($sm) {
		/* margin-right: 0; */
		margin-bottom: 10px;
		margin-right: 20px;
	}
}

.popup-product__input-wrap {
	position: relative;
	width: 143px;
	overflow: hidden;

	@include mq(1200px) {
		width: 125px;
	}
}

.popup-product__input {
	height: 57px;
	width: 100%;
	box-shadow: inset 2px 3px 4px rgba($happy-blue, 0.25);
	border-radius: 29px;
	border: 1px solid $ziggurat;
	background-color: $white;
	/* padding: 0 43px; */
	padding: 0 36px 0 36px;
	text-align: center;
	transition: border $dur $ease;
	font-size: 24px;
	font-weight: 400;
	letter-spacing: 1.2px;
	color: $cello;
	letter-spacing: 1px;
	-moz-appearance: textfield;

	&:focus {
		border: 2px solid $burning-orange;
	}

	&::-webkit-inner-spin-button,
	&::-webkit-outer-spin-button {
		appearance: none;
		opacity: 0;
	}

	@include mq($md) {
		font-size: 20px;
	}
}

.popup-product__decrement,
.popup-product__increment {
	position: absolute;
	top: 0;
	align-items: center;
	transition: color $dur $ease;
	cursor: pointer;

	&:hover {
		color: $happy-blue;
	}
}

.popup-product__decrement-ico,
.popup-product__increment-ico {
	font-size: 12px;
	width: 43px;
	height: 57px;
	align-items: center;
}

.popup-product__decrement {
	left: 0;

	&-ico {
		/* justify-content: flex-end; */
		justify-content: center;
	}
}

.popup-product__increment {
	right: 0;

	&-ico {
		/* justify-content: flex-start; */
		justify-content: center;
	}
}

.popup-product__footer-feed {
	display: inline-flex;
	align-items: center;
	font-family: $font-second;
	font-size: 18px;
	margin-left: 27px;

	.popup-products__feed-ico {
		font-size: 20px;
		width: 22px;
		height: 22px;
		margin-right: 6px;
	}

	@include mq(1200px) {
		margin-left: 10px;
		font-size: 16px;
	}

	@include mq(1024px) {
		font-size: 16px;
		margin-left: 25px;
	}

	@include mq($sm) {
		margin-left: 0;
		margin-top: 10px;
		font-size: 16px;
		width: 100%;
		justify-content: center;
	}
}

.popup-product__small {
	display: block;
	width: 100%;
	color: $happy-blue;
	font-family: $font-second;
	font-size: 18px;
	margin-top: 8px;

	@include mq(1200px) {
		width: auto;
		order: 2;
		font-size: 16px;
	}

	@include mq(1024px) {
		margin-top: 0;
	}

	@include mq(992px) {
		margin-top: 10px;
	}

	@include mq($sm) {
		font-size: 16px;
	}
}

.fade-enter-active, .fade-leave-active {
	transition: opacity $dur $ease;
}

.fade-enter, .fade-leave-to {
	opacity: 0;
}
</style>
